import React from 'react';
import { CheckCircle2, PlayCircle, XCircle } from 'lucide-react';
import { PhoneFrame } from '../components/mobile/PhoneFrame';
import { SplashScreen } from '../components/mobile/screens/SplashScreen';
import { LoginScreen } from '../components/mobile/screens/LoginScreen';
import { HomeScreen } from '../components/mobile/screens/HomeScreen';
import { ScannerScreen } from '../components/mobile/screens/ScannerScreen';
import { ResultScreen } from '../components/mobile/screens/ResultScreen';
import { OwnerScreen } from '../components/mobile/screens/OwnerScreen';
import { DriversScreen } from '../components/mobile/screens/DriversScreen';
import { DriverDetailScreen } from '../components/mobile/screens/DriverDetailScreen';
import { InvalidScreen } from '../components/mobile/screens/InvalidScreen';
import { ReportScreen } from '../components/mobile/screens/ReportScreen';
import { ReportDoneScreen } from '../components/mobile/screens/ReportDoneScreen';
import { SuccessScreen } from '../components/mobile/screens/SuccessScreen';
import { HistoryScreen } from '../components/mobile/screens/HistoryScreen';
import { SearchScreen } from '../components/mobile/screens/SearchScreen';
import { useMobileNav } from '../hooks/useMobileNav';
import { mobileScreenList } from '../data/mobileScreens';
import type { MobileNav, MobileScreen } from '../types/mobile';
const screens: Record<MobileScreen, React.ComponentType<{
  nav: MobileNav;
}>> = {
  splash: SplashScreen,
  login: LoginScreen,
  home: HomeScreen,
  scanner: ScannerScreen,
  result: ResultScreen,
  owner: OwnerScreen,
  drivers: DriversScreen,
  driver: DriverDetailScreen,
  invalid: InvalidScreen,
  report: ReportScreen,
  reportDone: ReportDoneScreen,
  success: SuccessScreen,
  history: HistoryScreen,
  search: SearchScreen
};
export function MobileApp() {
  const nav = useMobileNav('splash');
  const Screen = screens[nav.screen];
  const info = mobileScreenList.find(s => s.key === nav.screen);
  const jump = (s: MobileScreen) => {
    if (s === 'invalid' || s === 'report') nav.setScenario('invalid');
    if (s === 'report') nav.setReportContext('invalid');
    nav.reset(s);
  };
  return <div className="min-h-[calc(100vh-48px)] w-full bg-slate-100" data-id="element-3571" data-mp="m9k3ssbc0wr5">
      <div className="mx-auto flex max-w-[1320px] flex-col items-center gap-6 px-4 py-6 lg:flex-row lg:items-start lg:justify-center" data-id="element-3572" data-mp="mabnp5vkh61l">
        <aside className="w-full max-w-[320px] space-y-4 lg:sticky lg:top-16" data-id="element-3573" data-mp="3pqisjfppx9by">
          <div className="rounded-lg border border-border bg-white p-4 shadow-sm" data-id="element-3574" data-mp="3pofs01qxvxsz">
            <p className="text-[11px] font-semibold uppercase tracking-wide text-navy-600" data-id="element-3575" data-mp="3upn0k30wp10p">A. ট্রাফিক পুলিশ মোবাইল অ্যাপ</p>
            <h1 className="mt-1 font-heading text-lg font-bold text-navy-900" data-id="element-3576" data-mp="89sis7meeg3n">রোডসাইড যাচাই প্রোটোটাইপ</h1>
            <p className="mt-1 text-xs text-slate-500" data-id="element-3577" data-mp="37012xk06mtut">ফোনের ভেতরে সরাসরি ক্লিক করুন অথবা নিচের ফ্লো থেকে শুরু করুন।</p>
            <div className="mt-3 grid gap-2" data-id="element-3578" data-mp="3by2lm3tp4r5r">
              <button onClick={() => {
              nav.setScenario('valid');
              nav.reset('login');
            }} className="flex items-center gap-2 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2.5 text-left text-xs font-semibold text-emerald-800 hover:bg-emerald-100" data-id="element-3579" data-mp="3bx16no9k7kir">
                <CheckCircle2 className="h-4 w-4" data-id="element-3580" data-mp="1f4rrujx2by7r" />
                <span data-id="element-3581" data-mp="1f6cja0o2z11e">ফ্লো ১: বৈধ সিএনজি ও চালক যাচাই<span className="block font-normal text-emerald-700" data-id="element-3582" data-mp="1a5ezxkrc40yb">লগইন → স্ক্যান → গাড়ি → মালিক → ৩ চালক → সম্পন্ন</span></span>
              </button>
              <button onClick={() => {
              nav.setScenario('invalid');
              nav.reset('scanner');
            }} className="flex items-center gap-2 rounded-md border border-red-200 bg-red-50 px-3 py-2.5 text-left text-xs font-semibold text-red-800 hover:bg-red-100" data-id="element-3583" data-mp="15c2etklv6cab">
                <XCircle className="h-4 w-4" data-id="element-3584" data-mp="mf189vcnw449" />
                <span data-id="element-3585" data-mp="mg2tgsne66zp">ফ্লো ২: অবৈধ ফলাফল ও অনিয়ম রিপোর্ট<span className="block font-normal text-red-700" data-id="element-3586" data-mp="2mhtymv9lmmz4">স্ক্যান → যাচাই ব্যর্থ → রিপোর্ট → নিশ্চিতকরণ</span></span>
              </button>
            </div>
          </div>
          <div className="rounded-lg border border-border bg-white p-2 shadow-sm" data-id="element-3587" data-mp="2rihubu8rvrzo">
            <p className="px-2 pb-1.5 pt-1 text-[11px] font-semibold text-slate-500" data-id="element-3588" data-mp="2cpocw39xx1sd">সকল স্ক্রিন</p>
            <ul className="no-scrollbar max-h-[420px] overflow-y-auto" data-id="element-3589" data-mp="2hor4akwzz9hv">
              {mobileScreenList.map(s => <li key={s.key} data-id="element-3590" data-mp="28q5sd8m16sq2">
                  <button onClick={() => jump(s.key)} aria-current={nav.screen === s.key ? 'true' : undefined} className={`flex w-full items-center gap-2.5 rounded-md px-2 py-1.5 text-left text-[13px] ${nav.screen === s.key ? 'bg-navy-800 text-white' : 'text-slate-700 hover:bg-slate-100'}`} data-id="element-3591" data-mp="28r731bz4xd79">
                    <span className={`w-7 font-mono text-[11px] ${nav.screen === s.key ? 'text-navy-200' : 'text-slate-400'}`} data-id="element-3592" data-mp="3t5qv1c3p5g9s">{s.no}</span>
                    {s.label}
                  </button>
                </li>)}
            </ul>
          </div>
        </aside>

        <PhoneFrame dark={nav.screen === 'scanner'} toast={nav.toast} data-id="element-3593" data-mp="1chpyw1166fmt">
          <Screen nav={nav} data-id="element-3594" data-mp="1ra1iws1lslkm" />
        </PhoneFrame>

        <aside className="w-full max-w-[320px] lg:sticky lg:top-16" data-id="element-3595" data-mp="1mi08lbnzx4x8">
          <div className="rounded-lg border border-border bg-white p-4 shadow-sm" data-id="element-3596" data-mp="1mfxby8sc8djj">
            <p className="text-[11px] font-semibold text-slate-500" data-id="element-3597" data-mp="207bxam9pwqtr">বর্তমান স্ক্রিন</p>
            <p className="mt-1 flex items-center gap-2 font-heading text-base font-bold text-navy-900" data-id="element-3598" data-mp="1w70c98dg0ohr">
              <span className="rounded bg-navy-800 px-1.5 py-0.5 font-mono text-xs text-white" data-id="element-3599" data-mp="2a6t271h5b0oo">{info?.no}</span>
              {info?.label}
            </p>
            <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-3600" data-mp="fss2yfhoobo2">{info?.desc}</p>
          </div>
          <div className="mt-4 rounded-lg border border-border bg-white p-4 shadow-sm" data-id="element-3601" data-mp="auqmm2bn6qga">
            <p className="mb-2 flex items-center gap-1.5 text-xs font-semibold text-navy-900" data-id="element-3602" data-mp="2awq5u05pkhsh"><PlayCircle className="h-4 w-4" data-id="element-3603" data-mp="2fvjhro5ck0qj" />বর্তমান চালক শনাক্তকরণ পদ্ধতি</p>
            <ol className="list-inside list-decimal space-y-1.5 text-xs text-slate-600" data-id="element-3604" data-mp="2fxnjbzfrwnnn">
              <li data-id="element-3605" data-mp="2jvtm6wdhqj3a">সিএনজির QR স্টিকার স্ক্যান করে গাড়ির বৈধতা নিশ্চিত</li>
              <li data-id="element-3606" data-mp="2oxajyj0ohpfn">৩ জন অনুমোদিত চালকের ছবি চালকের চেহারার সাথে মিলিয়ে দেখা</li>
              <li data-id="element-3607" data-mp="2tvuayxu4prev">অথবা চালকের DMP QR কার্ড স্ক্যান করে সরাসরি শনাক্ত</li>
              <li data-id="element-3608" data-mp="2yufasw5gy92s">লাইসেন্সের মেয়াদ ও অবস্থা স্বয়ংক্রিয়ভাবে যাচাই</li>
              <li data-id="element-3609" data-mp="2yskq9iy40iz8">তালিকায় না থাকলে “অননুমোদিত চালক” রিপোর্ট</li>
            </ol>
          </div>
        </aside>
      </div>
    </div>;
}